import { Template01_Modern } from './Template01_Modern';

export { Template01_Modern };

export const FanTemplates = {
  Template01: () => import('./Template01_Modern').then(m => m.Template01_Modern),
} as const;

export default Template01_Modern;
